import * as React from "react";

import { Anchor, Text } from "grommet";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { usePath } from "../general/Helpers";

const LinkAnchor = ({ path, label }) => {
    const navigate = useNavigate();
    const pathname = usePath();
    const [basename, setBasename] = React.useState("");

    React.useEffect(() => {
        if (pathname.startsWith("/me")) {
            setBasename("/me");
        } else if (pathname.startsWith("/ue")) {
            setBasename("/ue");
        } else if (pathname.startsWith("/public")) {
            setBasename("/public");
        }
    }, [pathname]);

    return (
        <Anchor
            onClick={(e) => {
                navigate(path);
                e.preventDefault();
            }}
            href={`${basename}${path}`}
            label={<Text>{label}</Text>}
        ></Anchor>
    );
};

export default LinkAnchor;
